module.exports = __webpack_public_path__ + "static/media/formula1.2cf56152.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/formula1.svg
// module id = 377
// module chunks = 7